'use client';

import { useRutilusQuery } from '@graphql/client/useRutilusQuery';
import { FollowButton } from '../../../components/Clickables/Buttons/FollowButton';
import { useUserInfo } from '@domain/user/useUserInfo';
import { getBrandIsFollowed } from '@graphql/queries/rutilus/Brands';

export const PageFollowButton = ({
  pageId,
  displayName,
}: {
  pageId: string;
  displayName: string;
}) => {
  const { isLoggedIn } = useUserInfo();
  const { data: followData, loading } = useRutilusQuery(getBrandIsFollowed, {
    variables: { externalId: pageId },
    skip: !isLoggedIn,
  });
  const followedByCurrentUser = followData?.entry.followedByCurrentUser ?? false;

  const showFollowButton = !isLoggedIn || (!loading && followData);

  if (!showFollowButton) {
    return <></>;
  }

  return (
    <FollowButton
      source="brand-follow-button"
      isFollowed={followedByCurrentUser}
      id={pageId}
      buttonProps={{ className: 'w-full', style: { borderRadius: 0 } }}
      customAppDownloadHeader={
        followedByCurrentUser
          ? `Download the Fishbrain app to unfollow ${displayName}`
          : `Download the Fishbrain app to follow ${displayName}`
      }
    />
  );
};
